import { PriceDetail } from "@repo/apis/browse-search-v2";

export const getDiscountPercentage = (
  current: PriceDetail,
  previous: PriceDetail,
) => {
  if (!previous.value || !current.value) return 0;

  if (previous.value <= 0 || current.value >= previous.value) {
    return 0;
  }

  return Math.round(((previous.value - current.value) / previous.value) * 100);
};
